var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export default class CopyImageService {
    static isSupported() {
        return (typeof navigator !== "undefined" &&
            !!navigator.clipboard &&
            typeof ClipboardItem !== "undefined" &&
            // // This doesn't work on Safari :/
            !new RegExp("^((?!chrome|android).)*safari", "i").test(navigator.userAgent));
    }
    static copyImage(blob) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(yield CopyImageService.isSupported())) {
                throw new Error("Copying an image is not supported");
            }
            return navigator.clipboard.write([
                new ClipboardItem({
                    [blob.type]: Promise.resolve(blob),
                }),
            ]);
        });
    }
}
